var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.screenShotData)?_c('div',{staticClass:"screen-shot-wrapper"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showScreenShot),expression:"showScreenShot"}],ref:"screenshot",staticClass:"screen-component"},[_c(_vm.screenShotData.component_name,{tag:"component",attrs:{"config":_vm.screenShotData.component_config}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }